import React, { useState, useEffect, useLayoutEffect } from "react";
import { RotateCw, DollarSign, CreditCard, TrendingUp, Zap, Lock, Unlock, Pencil, Shield, Upload, Key, Heart, AlertCircle, Coins } from "lucide-react";
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../ui/dialog';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../ui/alert-dialog';
import { useParams } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import PrimaryTabs from "./PrimaryTabs";
import {
  formatMoney,
  getDateTimeFormate,
  hideInfo,
  hideMobile,
  getCurrencySymbol,
  formatAmountByCurrency,
  amountUnitConversion,
} from "../../sharedfiles/helper";
import { apiCaller } from "../../api/apiCaller";
import { betDecisionApis as riskApis, playerapi } from "../../sharedfiles/EndpointConfig";

import { getPlayerGeneralDetail } from "../GeneralDetail/GeneralDetailSlice";
import { setaddMakeManualId } from "../paymentHistory/paymentHistoryTableSlice";
import {
  getFinancials,
  getPlayer,
  getBonuswidgetTableList,
  getKycType,
  userControl,
  setAddressDocs,
  setIdedntityDocs,
  uploadKycDetails,
  reqestKyc,
} from "../primaryplayer/PrimaryPlayerSlice";
import { setAddNoteValue } from "../AddNote/addNoteSlice";
import { setUserId } from "../playerTable/playerSearchTableSlice";
import Kyc from "./Kyc";
import ResetPassword from "./ResetPassword";
import EditPlayerDetails from "./EditPlayerDetails";
import { setIntervalStopper } from "../AppSlice";
import {
  COMMON_CONSTANTS,
  PRIMARYPLAYER_CONSTANTS,
  kycOptions,
} from "../../sharedfiles/Constants";
import { PLAYER_MODULE } from "../../sharedfiles/tooltipMsgs";
import { userStatus } from "../Common/data/Players/PlayersData";
import Select from "../Common/inputs/SelectDropdown";
import { getUpdatedLimits } from "../PaymentLimitTab/LimitsTabSlice";
import { getUserStakes } from "../UserStakeSetting/UserStakeSlice";
import Input from "../Common/inputs/Input";
import { addToUserWatchList } from "../UsersWatchlist/userWatchListSlice";
import CommentBox from "../Common/CommentBox";
import { getUserRolePermissionV2 } from "../CreatePermission/CreatePermissionSlice";
import { getBrandCurrenciesList } from "../createbonusnew/createbonusnewslice";

// Risk score (0.00 - 1.00) -> user persona label/color, computed on FE per business rules
// (the API's own risk_label is intentionally ignored in favor of this mapping)
const RISK_SCORE_BANDS = [
  { min: 0.90, label: "High Value Casual", color: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400" },
  { min: 0.60, label: "Standard Recreational", color: "bg-lime-100 text-lime-700 dark:bg-lime-900/30 dark:text-lime-400" },
  { min: 0.40, label: "Neutral", color: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400" },
  { min: 0.20, label: "Soft Sharp", color: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400" },
  { min: 0, label: "Critical Risk", color: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400" },
];

const getRiskScoreLevel = (score) => {
  const numericScore = Number(score);
  if (score === null || score === undefined || Number.isNaN(numericScore)) return null;
  return RISK_SCORE_BANDS.find((band) => numericScore >= band.min) || RISK_SCORE_BANDS[RISK_SCORE_BANDS.length - 1];
};

const PrimaryPlayer = (props) => {
  const dispatch = useDispatch();
  const [kycdialog, setKycdialog] = useState(false);
  const [openResetDialog, setOpenResetDialog] = useState(false);
  const [openEditBox, setOpenEditBox] = useState(false);
  const [openconfirmModal, setOpenConfirmModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);
  const [masking, setMasking] = useState(false);
  const [userSts, setUserSts] = useState("");
  const [openWatchlist, setOpenWatchlist] = useState(false);
  const [watchListCmnt, setWatchListCmnt] = useState("");
  const [emptyErr, setEmptyErr] = useState(false);
  const [uploadKyc, setUploadKyc] = useState(false);
  const [kycType, setKycType] = useState("");
  const [idType, setIdType] = useState("");
  const [fileValue, setFileValue] = useState("");
  const [formValid, setFormValid] = useState(false);
  const playerStatus = props.playerInfo.accountStatus;
  const [reKyc, setReKyc] = useState(false);
  const [isReqKycDisable, setIsReqKycDisable] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [showEditButton, setShowEditButton] = useState(false);
  const [showUserStatus, setShowUserStatus] = useState(false);
  const intervalStopper = useSelector(
    (state) => state.appslice.intervalStopper
  );
  // const playerData = useSelector((state) => state.primaryplayer.playerData);
  // const permissionList = useSelector(
  //   (state) => state.createPermission.permissionList
  // );
  const userRolePermissionList = useSelector((state) => state.createPermission.userRolePermissionList);
  const riskSummaryRefreshToken = useSelector((state) => state.appslice.riskSummaryRefreshToken);
  const [plSummaryData, setPlSummaryData] = useState({});
  // Same currency source as the Create Bonus page
  const brandCurrenciesList = useSelector((state) => state.bonus.brandCurrenciesList);
  const currencyOptions = brandCurrenciesList || [];
  // Brand default currency, stored in localStorage when the brand is selected
  const getDefaultSummaryCurrency = () => {
    const brandCurrency = localStorage.getItem("currency");
    if (!currencyOptions.length) return brandCurrency || "";
    return currencyOptions.some((c) => c.value === brandCurrency) ? brandCurrency : currencyOptions[0]?.value || "";
  };
  const [summaryCurrency, setSummaryCurrency] = useState(getDefaultSummaryCurrency);

  useEffect(() => {
    if (!brandCurrenciesList?.length) {
      dispatch(getBrandCurrenciesList());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Default to the brand currency (or the first one if it's not in the list) whenever the currency list loads/changes
  useEffect(() => {
    setSummaryCurrency(getDefaultSummaryCurrency());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandCurrenciesList]);
  const [summaryRefreshKey, setSummaryRefreshKey] = useState(0);

  const [isBetCorrectBrand, setIsBetCorrectBrand] = useState(false);

  const checkBrandName = () => {
    const currentBrandId = localStorage.getItem("brandId");
    if (currentBrandId === "268") {
      setIsBetCorrectBrand(true);
    } else {
      setIsBetCorrectBrand(false);
    }
  };

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      if (localStorage.getItem("isMasking") === "DATA_MASKING") {
        setMasking(true);
      } else {
        setMasking(false);
      }
      checkBrandName();
      //dispatch(getRolePermission());
      dispatch(getUserRolePermissionV2());
    }
    return () => (mounting = false);
  }, [dispatch]);

  useEffect(() => {
    if (userRolePermissionList && userRolePermissionList.length > 0) {
      if (isBetCorrectBrand) {
        setShowButton(userRolePermissionList.some((p) => p.permissionName === "ADMIN_RESET_PASSWORD"));
        setShowEditButton(userRolePermissionList.some((p) => p.permissionName === "PLAYER_DETAILS_CHECK"));
        setShowUserStatus(userRolePermissionList.some((p) => p.permissionName === "USER_STATUS_CHECK"));
      } else {
        setShowButton(true);
        setShowEditButton(true);
        setShowUserStatus(true);
      }
    } else if (!isBetCorrectBrand) {
      setShowButton(true);
      setShowEditButton(true);
      setShowUserStatus(true);
    }
  }, [userRolePermissionList, isBetCorrectBrand]);

  useEffect(() => {
    checkBrandName();
  }, [props.brandData]);
  const { id } = useParams();

  // INT-11513: new per-section summary APIs feeding the Financials, Betting, Balance (Real) and Risk sections
  const [accountSummary, setAccountSummary] = useState({});
  const [financialsSummary, setFinancialsSummary] = useState({});
  const [betsSummary, setBetsSummary] = useState({});
  const [riskSummary, setRiskSummary] = useState({});
  useEffect(() => {
    if (!id) return;
    let active = true;
    setAccountSummary({});
    setFinancialsSummary({});
    setBetsSummary({});
    setRiskSummary({});
    const sections = [
      { section: "account", color: "#2563eb", setData: setAccountSummary },
      { section: "bets", color: "#d97706", setData: setBetsSummary },
      { section: "financials", color: "#16a34a", setData: setFinancialsSummary },
      { section: "risk", color: "#9333ea", setData: setRiskSummary },
    ];
    sections.forEach(({ section, color, setData }) => {
      const label = `%c[INT-11513] summary/${section}${summaryCurrency ? ` (${summaryCurrency})` : ""}`;
      const style = `background:${color};color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px`;
      apiCaller(playerapi.getPlayerSectionSummary(id, section, summaryCurrency), "GET")
        .then((response) => {
          console.log(label, style, response);
          // Ignore responses for a previous player/currency selection
          if (active && setData && response?.status === 200 && Array.isArray(response?.data)) {
            setData(response.data[0] || {});
          }
        })
        .catch((error) => console.log(`${label} FAILED`, "background:#dc2626;color:#fff;font-weight:bold;padding:2px 6px;border-radius:3px", error));
    });
    return () => {
      active = false;
    };
  }, [id, summaryCurrency, summaryRefreshKey]);

  // Summary amounts come in the currency's minor units (x100 or x10^10)
  const summaryCurrencyCode =
    accountSummary?.currencyCode || financialsSummary?.currencyCode || betsSummary?.currencyCode || riskSummary?.currencyCode || summaryCurrency;
  const formatSummaryAmount = (amount) =>
    summaryCurrencyCode ? formatAmountByCurrency(amount ?? 0, summaryCurrencyCode) : formatMoney(amount);
  const formatSummaryDate = (date) => (date ? getDateTimeFormate(date) : "");

  const onEditplayer = (e) => {
    e.preventDefault();
    setOpenEditBox(true);
    dispatch(getPlayerGeneralDetail({ user_id: id }));
  };
  const kycHandler = (val) => {
    setKycdialog(val);
    val && dispatch(getKycType());
  };
  const resetPasswordHandler = (value) => {
    setOpenResetDialog(value);
    props.dispatch(setIntervalStopper(value));
  };

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      if (localStorage.getItem("isMasking") === "DATA_MASKING") {
        setMasking(true);
      } else {
        setMasking(false);
      }
    }
    return () => (mounting = false);
  }, []);

  useEffect(() => {
    if (playerStatus) {
      setUserSts(playerStatus);
    }
  }, [playerStatus]);

  useEffect(() => {
    let mounting = true;
    if (mounting) {
      localStorage.setItem("userId", id);
      dispatch(setAddNoteValue(id));
      dispatch(setaddMakeManualId(id));
      dispatch(getKycType());
      dispatch(setAddressDocs([]));
      dispatch(setIdedntityDocs([]));
      dispatch(setUserId(id));
      dispatch(getPlayerGeneralDetail({ user_id: id }));
      dispatch(getFinancials({ user_id: id }));
      dispatch(getPlayer({ user_id: id }));
      dispatch(getUpdatedLimits(id));
      // dispatch(getUserStakes(id)); // commented out - stake/preference API disabled per request
      dispatch(getBonuswidgetTableList({ user_id: id }));
    }
    return () => (mounting = false);
  }, [id, dispatch]);

  useEffect(() => {
    if (!id) {
      setPlSummaryData({});
      return;
    }
    const url = riskApis.getCustomerRiskSummary(parseInt(id));
    apiCaller(url, "GET")
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setPlSummaryData(response.data);
        } else {
          setPlSummaryData({});
        }
      })
      .catch(() => setPlSummaryData({}));
  }, [id, riskSummaryRefreshToken]);

  const plCustomerInfo = plSummaryData?.customer_info || {};
  const riskScoreLevel = getRiskScoreLevel(plCustomerInfo?.risk_score);
  const formatPlAmount = (value) =>
    value === null || value === undefined
      ? "-"
      : Number(value).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // This page fires ~8 parallel API calls on mount (above). On a cold first
  // load (empty Redux state) those can keep growing the page's height for a
  // while; on a later visit in the same session, Redux/browser cache already
  // has data so the page reaches full height almost immediately. A fixed
  // retry window can't fit both, so instead keep reapplying the saved scroll
  // position as long as the page keeps resizing, and only stop once it's
  // been quiet for a bit (with a generous hard cap as a safety net). Backed
  // by sessionStorage so it survives a full reload too.
  //
  // useLayoutEffect, not useEffect: on unmount, this page's content is
  // removed from `container`, and the browser auto-clamps scrollTop to fit
  // the new (shorter) content - firing a native "scroll" event as part of
  // that same synchronous layout pass. useEffect cleanups run asynchronously
  // after paint, so there's a race: sometimes React detaches the listener
  // before that clamp event fires, sometimes it doesn't (depending on main-
  // thread load), which is why this was intermittent. useLayoutEffect's
  // cleanup runs synchronously in the same commit as the DOM removal,
  // guaranteed to detach the listener before that clamp/event can happen.
  useLayoutEffect(() => {
    const container = document.getElementById("main-scroll-container");
    if (!container || !id) return;

    const storageKey = `primaryPlayerScrollY_${id}`;
    const saved = Number(sessionStorage.getItem(storageKey)) || 0;

    const applyPosition = () => {
      container.scrollTo({ top: saved, behavior: "instant" });
    };
    applyPosition();

    // Debounced, not immediate: when this page unmounts (navigating to a
    // different tab), its content is removed from `container` and the
    // browser auto-clamps scrollTop toward 0 to fit the new (much shorter)
    // content - and that clamp itself fires a native "scroll" event. Writing
    // on every event would let that spurious post-unmount event overwrite the
    // real position with 0. Debouncing means the real position (written
    // ~150ms after the user stops scrolling, while still mounted) is already
    // safely saved well before a navigation click happens; the cleanup below
    // cancels any pending write so a stray unmount-triggered event never gets
    // persisted.
    let saveTimeoutId;
    const handleScroll = () => {
      clearTimeout(saveTimeoutId);
      saveTimeoutId = setTimeout(() => {
        sessionStorage.setItem(storageKey, String(container.scrollTop));
      }, 150);
    };
    container.addEventListener("scroll", handleScroll);

    let observer;
    let stabilityTimeoutId;
    let hardStopTimeoutId;
    if (saved > 0) {
      // Observe the CONTENT (main), not the scroll container itself - the
      // container's own box is fixed by the surrounding flex/h-screen layout,
      // so only its content's growth actually needs watching.
      const content = container.querySelector("main") || container;
      const stopObserving = () => {
        observer?.disconnect();
        clearTimeout(stabilityTimeoutId);
        clearTimeout(hardStopTimeoutId);
      };
      observer = new ResizeObserver(() => {
        applyPosition();
        // Content just changed again - push the "settled" deadline out further.
        clearTimeout(stabilityTimeoutId);
        stabilityTimeoutId = setTimeout(stopObserving, 1000);
      });
      observer.observe(content);
      stabilityTimeoutId = setTimeout(stopObserving, 1000);
      // Absolute ceiling so a page that somehow never stops resizing doesn't
      // observe forever.
      hardStopTimeoutId = setTimeout(stopObserving, 20000);
    }

    return () => {
      container.removeEventListener("scroll", handleScroll);
      clearTimeout(saveTimeoutId);
      observer?.disconnect();
      clearTimeout(stabilityTimeoutId);
      clearTimeout(hardStopTimeoutId);
    };
  }, [id]);

  useEffect(() => {
    if (localStorage.getItem("KYCDocumentDetails") === "ADMIN_KYC_DOCUMENTS") {
      setReKyc(true);
    }
  }, []);

  const update = (id) => {
    setTimeout(() => props.dispatch(getPlayer({ user_id: id })), 300);
  };

  const onChange = (e) => {
    const id = localStorage.getItem("userId");
    const value = e.target.value;
    setUserSts(value);
    switch (value) {
      case "ACTIVE":
        dispatch(userControl(id, "ACTIVE"));
        update(id);
        break;
      case "SUSPENDED":
        dispatch(userControl(id, "SUSPENDED"));
        update(id);
        break;
      case "WITHDRAW_DEACTIVATED":
        dispatch(userControl(id, "WITHDRAW_DEACTIVATED"));
        update(id);
        break;
      default:
        break;
    }
  };

  const onSave = (status) => {
    const id = localStorage.getItem("userId");
    dispatch(userControl(id, "SUSPENDED"));
    update(id);
  };

  const onActivate = () => {
    const id = localStorage.getItem("userId");
    dispatch(userControl(id, "ACTIVE"));
    update(id);
  };

  function intervalHandler() {
    const userId = localStorage.getItem("userId");
    props.dispatch(getFinancials({ user_id: userId }));
    props.dispatch(getBonuswidgetTableList({ user_id: userId }));
    setSummaryRefreshKey((key) => key + 1);
  }

  useEffect(() => {
    if (!intervalStopper) {
      setOpenResetDialog(false);
    }
  }, [intervalStopper]);

  const getBettingData = () => {
    const data = [
      {
        title: "LT Bet Stakes",
        value: formatMoney(
          props.financialData.betDetails &&
            props.financialData.betDetails.stakes !== null
            ? props.financialData.betDetails.stakes
            : "0"
        ),
      },
      {
        title: "LT Free Bet Cost",
        value: formatMoney(
          props.financialData.betDetails &&
            props.financialData.betDetails.freeBet
            ? props.financialData.betDetails.freeBet
            : "0"
        ),
      },
      {
        title: "Primary Channel",
        value:
          props.financialData.betDetails &&
          props.financialData.betDetails.primaryChannel.replace(/^\w/, (c) =>
            c.toUpperCase()
          ),
      },
      {
        title: "LT Bet Returns",
        value: formatMoney(
          props.financialData.betDetails &&
            props.financialData.betDetails.payout !== null
            ? props.financialData.betDetails.payout
            : "0"
        ),
      },
      {
        title: "LT GGR",
        value: formatMoney(
          props.financialData.betDetails &&
            props.financialData.betDetails.ggr !== null
            ? props.financialData.betDetails.ggr
            : "0"
        ),
      },
      {
        title: "Primary Sport",
        value:
          props.financialData.betDetails &&
          props.financialData.betDetails.primarySport,
      },
    ];
    return data;
  };
  const handleWatchlistOpen = () => {
    setOpenWatchlist(true);
  };
  const handleWatchlistClose = () => {
    setOpenWatchlist(false);
    setWatchListCmnt("");
  };

  const onIpChange = (e) => {
    const { value } = e.target;
    setWatchListCmnt(value);
    value === "" ? setEmptyErr(true) : setEmptyErr(false);
  };

  const onCmntSave = () => {
    const userID = localStorage.getItem("userId");
    const payload = {
      comments: watchListCmnt,
      watchUserId: userID,
    };
    if (watchListCmnt === "") {
      setEmptyErr(true);
    } else {
      dispatch(addToUserWatchList(payload));
      setOpenWatchlist(false);
      setEmptyErr(false);
    }
    setTimeout(() => dispatch(getPlayer({ user_id: userID })), 300);
    setTimeout(() => {
      setWatchListCmnt("");
    }, 500);
  };

  useEffect(() => {
    const isFormValid = !!(kycType && idType && fileValue);
    setFormValid(isFormValid);
  }, [kycType, idType, fileValue]);

  const openKyc = () => {
    setUploadKyc(true);
  };
  const handleKycClose = () => {
    setUploadKyc(false);
  };
  const handleChange = (e) => {
    setIdType(e.target.value);
  };
  const handleUpload = (e) => {
    const { name } = e.target;
    if (name === "uploadTag") {
      setFileValue(e.target.files[0]);
    }
  };
  const onCancel = () => {
    setKycType("");
    setIdType("");
    setFileValue("");
  };

  const handleKycChange = (e) => {
    const value = e.target.value;
    setKycType(value);
  };

  const onUpload = () => {
    const formData = new FormData();
    setUploadKyc(false);
    formData.append("file", fileValue);
    const userId = localStorage.getItem("userId");
    dispatch(uploadKycDetails(idType, kycType, userId, formData));
    onCancel();
  };
  const handleReqKyc = () => {
    const userId = localStorage.getItem("userId");
    setIsReqKycDisable(true);
    setTimeout(() => {
      setIsReqKycDisable(false);
    }, 3000);
    dispatch(reqestKyc(userId));
  };

  return (
    <>
      <Dialog open={openWatchlist} onOpenChange={handleWatchlistClose}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Add to Watchlist</DialogTitle>
          </DialogHeader>
          <CommentBox
            placeholder={"Mention Your Comment Here"}
            value={watchListCmnt}
            errorMsg={emptyErr && "Please provide a comment"}
            onIpChange={(e) => onIpChange(e)}
            onSave={(e) => onCmntSave(e)}
            onCancel={() => handleWatchlistClose()}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={uploadKyc} onOpenChange={handleKycClose}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Upload KYC Document</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <Select
              title={"KYC Type"}
              name={"kycType"}
              value={kycType}
              setValue={(e) => handleKycChange(e)}
              options={kycOptions}
              ids={"kyctype"}
              info={PRIMARYPLAYER_CONSTANTS.kyc_type}
            />
            <Input
              title={"ID Type"}
              name={"idtype"}
              value={idType}
              placeholder={"Enter ID Type"}
              setValue={(e) => handleChange(e)}
              ids={"idtype"}
              info={"Select the type of ID"}
            />
            <Input
              title={"Upload File"}
              placeholder={"Choose file"}
              name={"uploadTag"}
              type={"file"}
              ids={"uploadFile"}
              show={true}
              info={"Upload KYC document (JPEG, PNG, SVG, TIFF)"}
              accept={"image/jpeg,image/png,image/svg,image/tiff"}
              setValue={(e) => handleUpload(e)}
            />
          </div>
          <DialogFooter className="flex justify-end gap-2 pt-6 border-t">
            <Button
              onClick={() => {
                onCancel();
                handleKycClose();
              }}
              type={"button"}
              variant="outline"
            >
              {COMMON_CONSTANTS.cancel}
            </Button>
            <Button
              onClick={(e) => onUpload(e)}
              type={"button"}
              disabled={!formValid}
            >
              {COMMON_CONSTANTS.Upload}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Kyc kycdialog={kycdialog} setKycdialog={kycHandler} />
      <Dialog open={openResetDialog} onOpenChange={resetPasswordHandler}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Reset Password</DialogTitle>
          </DialogHeader>
          <ResetPassword onCancel={() => resetPasswordHandler(false)} />
        </DialogContent>
      </Dialog>
      <AlertDialog open={openconfirmModal} onOpenChange={setOpenConfirmModal}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Deactivate Account</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to deactivate this account? This action cannot be easily undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onSave()}>Deactivate</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog open={activateModal} onOpenChange={setActivateModal}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Activate Account</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to activate this account?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={() => onActivate()}>Activate</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {openEditBox && (
        <EditPlayerDetails
          openEditBox={openEditBox}
          setOpenEditBox={setOpenEditBox}
        />
      )}
      <div className="space-y-6">
        {/* Player Header & Actions Section */}
        <div className="rounded-lg border shadow-sm overflow-hidden bg-gradient-to-br from-blue-50/60 via-indigo-50/30 to-slate-50 dark:from-slate-900 dark:via-slate-800/60 dark:to-slate-900">

          {/* Row 1: Name + utility buttons */}
          <div className="px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-b border-border">
            <div className="min-w-0">
              {props.playerInfo && (props.playerInfo?.firstName || props.playerInfo?.lastName) ? (
                <h2 className="text-xl font-bold text-foreground truncate">
                  {masking && props.playerInfo && Object.keys(props.playerInfo).length > 0 && Number(props.playerInfo?.firstName)
                    ? hideMobile(props.playerInfo?.firstName)
                    : props.playerInfo?.firstName}
                  &nbsp;
                  {masking && props.playerInfo && Object.keys(props.playerInfo).length > 0 && Number(props.playerInfo?.lastName)
                    ? hideMobile(props.playerInfo?.lastName)
                    : props.playerInfo?.lastName}
                </h2>
              ) : (
                <h2 className="text-xl font-bold text-muted-foreground/40 truncate">— No name on record —</h2>
              )}
              {!masking && props.playerInfo && Object.keys(props.playerInfo).length > 0 && (
                <p className="text-xs text-muted-foreground mt-0.5">
                  {hideInfo(props.playerInfo?.userName, 1, true)}
                </p>
              )}
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {showEditButton && (
                <Button onClick={(e) => onEditplayer(e)} type="button" id="editPlayer" variant="outline" size="sm" disabled={props.viewOnlyuser} className="gap-1.5">
                  <Pencil className="h-3.5 w-3.5" />
                  <span className="hidden sm:inline">Edit</span>
                </Button>
              )}
              {showButton && (
                <Button onClick={() => resetPasswordHandler(true)} type="button" id="resetPassword" variant="outline" size="sm" disabled={props.viewOnlyuser} className="gap-1.5">
                  <Key className="h-3.5 w-3.5" />
                  <span className="hidden sm:inline">Reset Password</span>
                </Button>
              )}
              <Button variant="outline" size="sm" onClick={() => intervalHandler()} className="gap-1.5">
                <RotateCw className="h-3.5 w-3.5" />
                <span className="hidden sm:inline">Refresh</span>
              </Button>
            </div>
          </div>

          {/* Row 2: User Status | Watchlist | KYC — flat controls bar */}
          <div className="px-5 py-4 flex flex-wrap items-center gap-3">

            {/* User Status dropdown */}
            {showUserStatus && (
              <div className={`w-52 shrink-0 ${props.viewOnlyuser ? "opacity-50 pointer-events-none" : ""}`}>
                <Select
                  title={""}
                  name={"userStatus"}
                  value={userSts}
                  setValue={(e) => onChange(e)}
                  options={userStatus}
                  ids={"PlayerCurrency"}
                  info={PLAYER_MODULE.userStatus}
                />
              </div>
            )}

            {/* Watchlist button */}
            <Button
              onClick={handleWatchlistOpen}
              variant={props.playerInfo?.isWatched ? "outline" : "default"}
              size="sm"
              disabled={props.playerInfo?.isWatched || props.viewOnlyuser}
              className="gap-1.5 shrink-0"
            >
              <Heart className={`h-3.5 w-3.5 ${props.playerInfo?.isWatched ? "fill-red-500 text-red-500" : ""}`} />
              {props.playerInfo?.isWatched ? "Watching" : "Add to Watchlist"}
            </Button>

            {/* KYC section */}
            <div className="flex items-center gap-2 flex-wrap sm:ml-auto">
              {/* KYC status badge */}
              {props.playerInfo.kycStatus === "KYC_PASSED" && (
                <span className="inline-flex items-center gap-1 text-xs font-medium text-green-700 bg-green-100 dark:bg-green-950/40 dark:text-green-400 px-2.5 py-1 rounded-full">
                  <div className="h-1.5 w-1.5 rounded-full bg-green-600"></div>
                  KYC Verified
                </span>
              )}
              {props.playerInfo.kycStatus === "KYC_REQUESTED" && (
                <span className="inline-flex items-center gap-1 text-xs font-medium text-amber-700 bg-amber-100 dark:bg-amber-950/40 dark:text-amber-400 px-2.5 py-1 rounded-full">
                  <div className="h-1.5 w-1.5 rounded-full bg-amber-500 animate-pulse"></div>
                  KYC Pending
                </span>
              )}
              {props.playerInfo.kycStatus !== "KYC_PASSED" && props.playerInfo.kycStatus !== "KYC_REQUESTED" && (
                <span className="inline-flex items-center gap-1 text-xs font-medium text-red-700 bg-red-100 dark:bg-red-950/40 dark:text-red-400 px-2.5 py-1 rounded-full">
                  <div className="h-1.5 w-1.5 rounded-full bg-red-500"></div>
                  KYC Not Verified
                </span>
              )}

              <Button
                variant="outline"
                size="sm"
                id="KYCbtn"
                onClick={() => kycHandler(true)}
                disabled={props.viewOnlyuser}
                className="gap-1.5"
              >
                <Shield className="h-3.5 w-3.5" />
                {PRIMARYPLAYER_CONSTANTS.player_kyc}
              </Button>

              <Button
                id="kycUpload"
                onClick={openKyc}
                size="sm"
                disabled={props.viewOnlyuser}
                className="gap-1.5"
                variant={
                  props.playerInfo.kycStatus !== "KYC_PASSED" && props.playerInfo.kycStatus !== "KYC_REQUESTED"
                    ? "default"
                    : "outline"
                }
              >
                <Upload className="h-3.5 w-3.5" />
                Upload KYC
              </Button>

              {reKyc && (
                <Button
                  id="kycRequest"
                  onClick={handleReqKyc}
                  size="sm"
                  disabled={isReqKycDisable || props?.playerInfo?.kycStatus !== "KYC_PASSED"}
                  className="gap-1.5"
                  variant={
                    !isReqKycDisable && props?.playerInfo?.kycStatus === "KYC_PASSED"
                      ? "default"
                      : "outline"
                  }
                >
                  Request KYC
                </Button>
              )}
            </div>

          </div>

          {/* KYC warning — only shown when unverified */}
          {props.playerInfo.kycStatus !== "KYC_PASSED" && props.playerInfo.kycStatus !== "KYC_REQUESTED" && (
            <div className="px-5 py-2.5 border-t border-border bg-destructive/5 flex items-center gap-2">
              <AlertCircle className="h-3.5 w-3.5 text-destructive shrink-0" />
              <p className="text-xs text-destructive">{PRIMARYPLAYER_CONSTANTS.kyc_verifyMsg}</p>
            </div>
          )}

        </div>

        {/* Summary toolbar - currency applies to all summary cards below */}
        <div className="rounded-lg border bg-card shadow-sm px-5 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <Coins className="h-5 w-5 text-muted-foreground shrink-0" />
            <div className="min-w-0">
              <h3 className="text-base font-semibold">Player Summary</h3>
              <p className="text-xs text-muted-foreground truncate">
                Amounts below are shown in {summaryCurrencyCode || "the selected currency"}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Label htmlFor="summaryCurrency" className="text-sm text-muted-foreground shrink-0">
              Currency
            </Label>
            <div className="flex-1 sm:flex-none sm:w-44">
              <Select
                name={"summaryCurrency"}
                ids={"summaryCurrency"}
                value={summaryCurrency}
                setValue={(e) => setSummaryCurrency(e.target.value)}
                options={currencyOptions}
                size="sm"
                noSelectOpt
                disabled={!currencyOptions.length}
              />
            </div>
          </div>
        </div>

        {/* Financial & Betting Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-6">
            <div className="rounded-lg border bg-card shadow-sm">
              <div className="p-5 border-b flex items-center gap-2">
                <DollarSign className="h-5 w-5 text-green-600" />
                <h3 className="text-base font-semibold">
                  {PRIMARYPLAYER_CONSTANTS.header_Financials}
                </h3>
              </div>
              <div className="p-5">
                <div className="grid grid-cols-3 gap-3">
                  {/* Deposits */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_Deposits}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.totalDeposit)}
                    </p>
                  </div>

                  {/* Withdrawals */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_Withdrawals}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.netWithdrawal)}
                    </p>
                  </div>

                  {/* Last Deposit Amount */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_lastDepoAmount}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(financialsSummary?.lastDeposit)}
                    </p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {formatSummaryDate(financialsSummary?.lastDepositedDate)}
                    </p>
                  </div>

                  {/* Manual Deposits */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_manualDeposits}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.totalManualDeposit)}
                    </p>
                  </div>

                  {/* Last Manual Deposit */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_lastManualDepo}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(financialsSummary?.lastManualDeposit)}
                    </p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {formatSummaryDate(financialsSummary?.lastManualDepositedDate)}
                    </p>
                  </div>

                  {/* Withdrawable Amount */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_withdrawableAmnt}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.withdrawls)}
                    </p>
                  </div>

                  {/* Pending Withdrawals */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_pendingWithdraw}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.pendingWithdrawals)}
                    </p>
                  </div>

                  {/* Stake After Last Deposit */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_stakeAfterlastDepo}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(financialsSummary?.totalStakeAfterDeposit)}
                    </p>
                  </div>

                  {/* Manual Withdrawals */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_withdrawals}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(accountSummary?.netManualWithdrawal)}
                    </p>
                  </div>

                  {/* Last Manual Withdrawal */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border">
                    <p className="text-xs text-muted-foreground mb-1">
                      {PRIMARYPLAYER_CONSTANTS.header_lastManualWithdraw}
                    </p>
                    <p className="text-base font-semibold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(financialsSummary?.lastManualWithdrawal)}
                    </p>
                    <p className="text-xs text-muted-foreground mt-0.5">
                      {formatSummaryDate(financialsSummary?.lastManualWithdrawalDate)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Betting Section */}
          <div className="lg:col-span-6">
            <div className="rounded-lg border bg-card shadow-sm h-full">
              <div className="p-5 border-b flex items-center gap-2">
                <Zap className="h-5 w-5 text-amber-500" />
                <h3 className="text-base font-semibold">
                  {PRIMARYPLAYER_CONSTANTS.header_betting}
                </h3>
              </div>
              <div className="p-5">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* LT Bet Stakes */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">LT Bet Stakes</p>
                    <p className="text-lg font-bold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(betsSummary?.stakes)}
                    </p>
                  </div>

                  {/* LT Free Bet Cost */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">LT Free Bet Cost</p>
                    <p className="text-lg font-bold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(betsSummary?.freeBet)}
                    </p>
                  </div>

                  {/* LT Bet Returns */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">LT Bet Returns</p>
                    <p className="text-lg font-bold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(betsSummary?.payout)}
                    </p>
                  </div>

                  {/* LT GGR */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">LT GGR</p>
                    <p className="text-lg font-bold text-foreground">
                      {summaryCurrencyCode}{" "}
                      {formatSummaryAmount(betsSummary?.ggr)}
                    </p>
                  </div>

                  {/* Primary Channel */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">Primary Channel</p>
                    <p className="text-lg font-bold text-foreground capitalize">
                      {betsSummary?.primaryChannel?.replace(/^\w/, (c) =>
                        c.toUpperCase()
                      )}
                    </p>
                  </div>

                  {/* Primary Sport */}
                  <div className="p-4 rounded-lg bg-gradient-to-br from-gray-50/50 to-gray-100/30 dark:from-gray-950/20 dark:to-gray-900/10 border border-gray-200 dark:border-gray-800">
                    <p className="text-xs font-medium text-muted-foreground mb-1">Primary Sport</p>
                    <p className="text-lg font-bold text-foreground">
                      {betsSummary?.primarySport}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Balance & Risk Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-6">
            <div className="rounded-lg border bg-card shadow-sm h-full flex flex-col">
              <div className="p-5 border-b flex items-center gap-2">
                <CreditCard className="h-5 w-5 text-blue-600" />
                <h3 className="text-base font-semibold">
                  {PRIMARYPLAYER_CONSTANTS.header_balance}
                </h3>
              </div>
              <div className="p-5">
                {Object.keys(props.BonusData).length > 0 ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {/* Real Balance */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5">Real</p>
                      <p className="text-base font-semibold">
                        {summaryCurrencyCode}{" "}
                        {Object.keys(accountSummary).length > 0
                          ? formatSummaryAmount(
                            accountSummary?.deposit +
                            accountSummary?.withdrawls
                          )
                          : "0"}
                      </p>
                    </div>

                    {/* Sports Locked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Lock className="h-3 w-3" /> Sports
                      </p>
                      <p className="text-base font-semibold">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.sportLockedBonus * 100)}
                      </p>
                    </div>

                    {/* Sports Unlocked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Unlock className="h-3 w-3" /> Sports
                      </p>
                      <p className="text-base font-semibold text-foreground">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.sportUnLockedBonus * 100)}
                      </p>
                    </div>

                    {/* Casino Locked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Lock className="h-3 w-3" /> Casino
                      </p>
                      <p className="text-base font-semibold">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.casinoLockedBonus * 100)}
                      </p>
                    </div>

                    {/* Casino Unlocked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Unlock className="h-3 w-3" /> Casino
                      </p>
                      <p className="text-base font-semibold text-foreground">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.casinoUnLockedBonus * 100)}
                      </p>
                    </div>

                    {/* New Games Locked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Lock className="h-3 w-3" /> Games
                      </p>
                      <p className="text-base font-semibold">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.neGameLockedBonus * 100)}
                      </p>
                    </div>

                    {/* New Games Unlocked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Unlock className="h-3 w-3" /> Games
                      </p>
                      <p className="text-base font-semibold text-foreground">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.neGameUnLockedBonus * 100)}
                      </p>
                    </div>

                    {/* Common Locked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Lock className="h-3 w-3" /> Bonus
                      </p>
                      <p className="text-base font-semibold">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.lockedBonus * 100)}
                      </p>
                    </div>

                    {/* Common Unlocked */}
                    <div className="p-2.5 rounded-md bg-muted/30 border border-border">
                      <p className="text-xs text-muted-foreground mb-0.5 flex items-center gap-1">
                        <Unlock className="h-3 w-3" /> Bonus
                      </p>
                      <p className="text-base font-semibold text-foreground">
                        {summaryCurrencyCode}{" "}
                        {formatMoney(props.BonusData?.unLockedBonus * 100)}
                      </p>
                    </div>

                    {/* Total Balance */}
                    <div className="p-2.5 rounded-md bg-primary/10 border border-primary/30 col-span-3">
                      <p className="text-xs font-semibold text-primary mb-0.5">Total Balance</p>
                      <p className="text-base font-bold text-primary">
                        {summaryCurrencyCode}{" "}
                        {Object.keys(accountSummary).length > 0
                          ? formatSummaryAmount(
                            accountSummary?.deposit +
                            accountSummary?.withdrawls +
                            amountUnitConversion((
                            props.bonusWidgetData?.unLockedBonus * 100 +
                            props?.bonusWidgetData?.lockedBonus * 100 +
                            props.BonusData?.sportLockedBonus * 100 +
                            props.BonusData?.sportUnLockedBonus * 100 +
                            props.BonusData?.casinoLockedBonus * 100 +
                            props.BonusData?.casinoUnLockedBonus * 100 +
                            props.BonusData?.neGameLockedBonus * 100 +
                            props.BonusData?.neGameUnLockedBonus * 100
                            ) / 100, summaryCurrencyCode)
                          )
                          : "0"}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-6">
                    <p className="text-muted-foreground text-sm">No balance data available</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-lg border bg-card shadow-sm h-full flex flex-col">
              <div className="p-5 border-b flex items-center gap-2">
                <TrendingUp className="h-5 w-5 text-muted-foreground" />
                <h3 className="text-base font-semibold">
                  {PRIMARYPLAYER_CONSTANTS.header_risk}
                </h3>
              </div>
              <div className="p-5 flex-1 overflow-y-auto">
                <div className="space-y-3">
                  {/* Single Bets / Combo Bets / Total Risk - single row */}
                  <div className="grid grid-cols-3 gap-2">
                    {/* Single Bets */}
                    <div className="p-3 rounded-md bg-muted/30 border border-border">
                      <h4 className="text-[11px] font-semibold text-muted-foreground mb-2 truncate">
                        {PRIMARYPLAYER_CONSTANTS.th_singleBets}
                      </h4>
                      <div className="space-y-1.5">
                        <div>
                          <p className="text-[10px] text-muted-foreground mb-0.5 truncate">
                            {PRIMARYPLAYER_CONSTANTS.th_openBets}
                          </p>
                          <p className="text-sm font-semibold truncate">
                            {summaryCurrencyCode}{" "}
                            {formatSummaryAmount(riskSummary?.singleBet?.openBets)}
                          </p>
                        </div>
                        <div>
                          <p className="text-[10px] text-muted-foreground mb-0.5 truncate">
                            {PRIMARYPLAYER_CONSTANTS.th_risk}
                          </p>
                          <p className="text-sm font-semibold text-foreground truncate">
                            {summaryCurrencyCode}{" "}
                            {formatSummaryAmount(riskSummary?.singleBet?.risk)}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Combo Bets */}
                    <div className="p-3 rounded-md bg-muted/30 border border-border">
                      <h4 className="text-[11px] font-semibold text-muted-foreground mb-2 truncate">
                        {PRIMARYPLAYER_CONSTANTS.th_comboBets}
                      </h4>
                      <div className="space-y-1.5">
                        <div>
                          <p className="text-[10px] text-muted-foreground mb-0.5 truncate">
                            {PRIMARYPLAYER_CONSTANTS.th_openBets}
                          </p>
                          <p className="text-sm font-semibold truncate">
                            {summaryCurrencyCode}{" "}
                            {formatSummaryAmount(riskSummary?.comboBet?.openBets)}
                          </p>
                        </div>
                        <div>
                          <p className="text-[10px] text-muted-foreground mb-0.5 truncate">
                            {PRIMARYPLAYER_CONSTANTS.th_risk}
                          </p>
                          <p className="text-sm font-semibold text-foreground truncate">
                            {summaryCurrencyCode}{" "}
                            {formatSummaryAmount(riskSummary?.comboBet?.risk)}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Total Risk */}
                    <div className="p-3 rounded-md bg-muted/30 border border-border flex flex-col justify-center">
                      <p className="text-[11px] text-muted-foreground font-semibold mb-0.5 truncate">Total Risk</p>
                      <p className="text-sm font-bold text-foreground truncate">
                        {summaryCurrencyCode}{" "}
                        {formatSummaryAmount(
                          (riskSummary?.singleBet?.risk || 0) +
                          (riskSummary?.comboBet?.risk || 0)
                        )}
                      </p>
                    </div>
                  </div>

                  {/* P&L Summary */}
                  <div className="p-3 rounded-md bg-muted/30 border border-border space-y-3">
                    <h4 className="text-[11px] font-semibold text-muted-foreground truncate">
                      P&amp;L Summary
                    </h4>

                    <div className="grid grid-cols-2 gap-2">
                      <div>
                        <p className="text-[10px] text-muted-foreground mb-0.5 truncate">Risk Score</p>
                        <span className={`inline-block text-xs font-semibold px-2 py-0.5 rounded-full ${riskScoreLevel?.color || ""}`}>
                          {plCustomerInfo?.risk_score} {riskScoreLevel?.label ? `(${riskScoreLevel.label})` : ""}
                        </span>
                      </div>
                      <div>
                        <p className="text-[10px] text-muted-foreground mb-0.5 truncate">Lifetime P/L</p>
                        <p className={`text-sm font-semibold truncate ${plCustomerInfo?.lifetime_pl >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"}`}>
                          {plCustomerInfo?.lifetime_pl != null && plCustomerInfo.lifetime_pl >= 0 ? "+" : "-"}
                          {getCurrencySymbol(plCustomerInfo?.lifetime_pl_currency)} {formatPlAmount(plCustomerInfo?.lifetime_pl != null ? Math.abs(plCustomerInfo.lifetime_pl) / 100 : null)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Primary Tabs */}
        <PrimaryTabs />
      </div>
    </>
  );
};
function mapStateToProps(state) {
  return {
    financialData: state.primaryplayer.financialData,
    dialogopen: state.primaryplayer.dialogopen,
    firstName: state.generaldetail.firstName,
    userId: state.playersearch.userId,
    playerInfo: state.primaryplayer.playerData,
    balanceData: state.primaryplayer.balanceData,
    bonusWidgetData: state.primaryplayer.bonusData,
    tagValue: state.primaryplayer.tagValue,
    paginationFirstValue: state.playersearch.paginationFirstValue,
    paginationSecondValue: state.playersearch.paginationSecondValue,
    // bonusData: state.bonusSlice.bonusData,
    BonusData: state.primaryplayer.bonusData,
    // successMessage: state.appslice.successMessage,
    // errorMessage: state.appslice.errorMessage,
    kycData: state.primaryplayer.kycData,
    kycType: state.primaryplayer.kycType,
    isPlayerExist: state.playersearch.isPlayerExist,
    viewOnlyuser: state.dashboard.viewOnlyuser,
  };
}
export default connect(mapStateToProps)(PrimaryPlayer);